//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
import { withTranslation } from 'react-i18next'; //------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { ArrowUp, ArrowDown } from '@cmp/images';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  toggle = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    const { title, text, className, t } = this.props;
    const { expanded } = this.state;
    const componentClasses = classNames(styles.Accordion, {
      [className]: className,
    });

    return (
      <div
        className={componentClasses}
        tabIndex={'0'}
        onKeyDown={(e) => {
          if (e.key === 'Enter') this.toggle();
        }}
      >
        <div className={styles.Divider} />
        <div className={styles.Summary} onClick={this.toggle}>
          <h1 className={styles.SummaryText}>{title}</h1>
          {expanded ? <ArrowUp /> : <ArrowDown />}
        </div>
        {expanded && <div className={styles.Details}>{text}</div>}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(Accordion);
